import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseurl } from '../../url';
import Navbar from './FacultyNavbar';
import './AttendanceForm.css';

const AttendanceSummary = () => {
  const [course, setCourse] = useState('');
  const [semester, setSemester] = useState('');
  const [subject, setSubject] = useState('');
  const [division, setDivision] = useState('');
  const [students, setStudents] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [commonDates, setCommonDates] = useState([]); // New state to hold common dates
  const [viewMode, setViewMode] = useState('regular');

  useEffect(() => {
    const fetchBranchesAndSemesters = async () => {
      const email = localStorage.getItem('email');

      try {
        const response = await axios.post(`${baseurl}/api/data/attendance`, { email });
        const { subjects, semesters, branches } = response.data;
        setCourses(branches || []);
        setSemesters(semesters || []);
        setSubjects(subjects || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchBranchesAndSemesters();
  }, []);

  const fetchAttendance = async () => {
    if (!course || !semester || !subject || (viewMode === 'monthly' && (!startDate || !endDate))) {
      console.error('Please select course, semester, subject, and date range');
      return;
    }

    try {
      const endpoint = viewMode === 'monthly' ? `${baseurl}/api/attendance/summary/monthly` : `${baseurl}/api/attendance/summary`;
      const response = await axios.post(`${endpoint}`, { course, semester, subject, division, startDate, endDate });
    // Set common dates
    const fetchedStudents = response.data.students || [];
    const fetchedAttendanceData = response.data.attendance || [];
    fetchedAttendanceData.sort((a, b) => a.RollNo - b.RollNo);
    // Sort students based on Roll No
    fetchedStudents.sort((a, b) => a.RollNo - b.RollNo);

    setStudents(fetchedStudents);
    setAttendanceData(fetchedAttendanceData);
    setCommonDates(response.data.commonDates || []);
    } catch (error) {
      console.error('Error fetching attendance summary:', error);
    }
  };

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const printRegularAttendance = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.open();
  
    let htmlContent = `
      <html>
        <head>
          <title> Attendance Summary of ${subject}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
            h1 {
              text-align: center;
            }
          </style>
        </head>
        <body>
          <h1>Regular Attendance of ${subject}</h1>
          <table>
            <thead>
              <tr>
                <th>Roll No</th>
                <th>Student Name</th>
               <th>No. of Present</th>
                <th>No. of Absent</th>
                <th>Total Attendance</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
    `;
  
    attendanceData.forEach((data, index) => {
      htmlContent += `
        <tr>
          <td>${data.RollNo}</td>
          <td>${students[index].name}</td>
             <td>${data.attendance.present}</td>
          <td>${data.attendance.absent}</td>
          <td>${data.attendance.total}</td>
          <td>${data.attendance.percentage}%</td>
        </tr>
      `;
    });
  
    htmlContent += `
            </tbody>
          </table>
        </body>
      </html>
    `;
  
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };
  

  const printMonthlyAttendance = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.open();
    
    let htmlContent = `
      <html>
        <head>
          <title>Monthly Attendance of ${subject}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
            h1 {
              text-align: center;
            }
            .date-range {
              margin-bottom: 20px;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <h1>Monthly Attendance Summary of ${subject}</h1>
          <div class="date-range">
            <p><strong>Date Range:</strong> ${formatDate(startDate)} to ${formatDate(endDate)}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Roll No</th>
                <th>Student Name</th>
                <th>No. of Present</th>
                <th>No. of Absent</th>
                <th>Total Attendance</th>
                <th>Percentage</th>
                
              </tr>
            </thead>
            <tbody>
    `;

    attendanceData.forEach((data, index) => {
      htmlContent += `
        <tr>
          <td>${data.RollNo}</td>
          <td>${students[index].name}</td>
          <td>${data.attendance.present}</td>
          <td>${data.attendance.absent}</td>
          <td>${data.attendance.total}</td>
          <td>${data.attendance.percentage}%</td>
         
      `;

    });

    htmlContent += `
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <div>
      <Navbar />
      <div className="attendance-form">
        <form onSubmit={(e) => { e.preventDefault(); fetchAttendance(); }}>
          {/* Same form elements for selecting course, semester, subject, etc. */}
          <label>
            Course:
            <select value={course} onChange={(e) => setCourse(e.target.value)}>
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course} value={course}>
                  {course}
                </option>
              ))}
            </select>
          </label>
          <label>
            Semester:
            <select value={semester} onChange={(e) => setSemester(e.target.value)}>
              <option value="">Select Semester</option>
              {semesters.map((semester) => (
                <option key={semester} value={semester}>
                  {semester}
                </option>
              ))}
            </select>
          </label>
          <label>
            Division:
            <select value={division} onChange={(e) => setDivision(e.target.value)}>
              <option value="">Select Division</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
          </label>
          <label>
            Subject:
            <select value={subject} onChange={(e) => setSubject(e.target.value)}>
              <option value="">Select Subject</option>
              {subjects.map((subject) => (
                <option key={subject} value={subject}>
                  {subject}
                </option>
              ))}
            </select>
          </label>

          <label>
            View Mode:
            <select value={viewMode} onChange={(e) => setViewMode(e.target.value)}>
              <option value="regular">Regular</option>
              <option value="monthly">Monthly</option>
            </select>
          </label>

          {viewMode === 'monthly' && (
            <>
              <label>
                Start Date:
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </label>
              <label>
                End Date:
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </label>
            </>
          )}

          <button type="submit">Fetch Attendance</button>
        
        </form>

        {viewMode === 'monthly' && commonDates.length > 0 && (
          <div className="common-dates">
            <h3>Attendance Marked Dates:</h3>
            <ul>
              {commonDates.map((date, idx) => (
                <li key={idx}>{formatDate(date)}</li>
              ))}
            </ul>
            <button type="button" onClick={printMonthlyAttendance}>
              Print Monthly Attendance
            </button>
          </div>
        )}
        {viewMode === 'regular' && students.length > 0 && (
  <button type="button" onClick={printRegularAttendance}>
    Print Regular Attendance
  </button>
)}


        {attendanceData.length > 0 && (
           <div className="atttable">
          <table>
            <thead>
              <tr>
                <th>Roll No</th>
                <th>Student Name</th>
                <th>No. of Present</th>
                <th>No. of Absent</th>
                <th>Total Attendance</th>
                <th>Percentage</th>
                <th>Absent Date</th>
                <th>Absent Hour</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.map((data, index) => (
                <tr key={students[index]._id}>
                  <td>{students[index].RollNo}</td>
                  <td>{students[index].name}</td>
                  <td>{data.attendance.present}</td>
                  <td>{data.attendance.absent}</td>
                  <td>{data.attendance.total}</td>
                  <td>{data.attendance.percentage}%</td>
                  <td>
                    {data.attendance.absentDetails.map((absent, idx) => (
                      <div key={idx}>
                       {formatDate(absent.date)}
                      </div>
                    ))}
                  </td>
                  <td>
                    {data.attendance.absentDetails.map((absent, idx) => (
                      <div key={idx}>
                       {absent.hour}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
   
  );
};

export default AttendanceSummary;
